"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutPaymentStatus = exports.CheckoutCancelActor = exports.CheckoutOrderType = exports.CheckoutDeliveryStatus = exports.CheckoutDeliveryProvider = exports.CheckoutMetaDataType = exports.CheckoutStatus = void 0;
var CheckoutStatus;
(function (CheckoutStatus) {
    CheckoutStatus[CheckoutStatus["Error"] = -2] = "Error";
    CheckoutStatus[CheckoutStatus["Canceled"] = -1] = "Canceled";
    CheckoutStatus[CheckoutStatus["Created"] = 0] = "Created";
    CheckoutStatus[CheckoutStatus["Ready"] = 1] = "Ready";
    CheckoutStatus[CheckoutStatus["Processing"] = 2] = "Processing";
    CheckoutStatus[CheckoutStatus["Authorized"] = 3] = "Authorized";
    CheckoutStatus[CheckoutStatus["Captured"] = 4] = "Captured";
    CheckoutStatus[CheckoutStatus["InProgress"] = 5] = "InProgress";
    CheckoutStatus[CheckoutStatus["Done"] = 6] = "Done";
    CheckoutStatus[CheckoutStatus["Received"] = 7] = "Received";
    CheckoutStatus[CheckoutStatus["ReadyToCollect"] = 8] = "ReadyToCollect";
    CheckoutStatus[CheckoutStatus["DeliveryInProgress"] = 9] = "DeliveryInProgress";
})(CheckoutStatus = exports.CheckoutStatus || (exports.CheckoutStatus = {}));
var CheckoutMetaDataType;
(function (CheckoutMetaDataType) {
    CheckoutMetaDataType["PenguinLockers"] = "PenguinLockers";
    CheckoutMetaDataType["Wallet"] = "Wallet";
})(CheckoutMetaDataType = exports.CheckoutMetaDataType || (exports.CheckoutMetaDataType = {}));
var CheckoutDeliveryProvider;
(function (CheckoutDeliveryProvider) {
    CheckoutDeliveryProvider[CheckoutDeliveryProvider["None"] = 0] = "None";
    CheckoutDeliveryProvider[CheckoutDeliveryProvider["Outlet"] = 1] = "Outlet";
    CheckoutDeliveryProvider[CheckoutDeliveryProvider["Wolt"] = 2] = "Wolt";
})(CheckoutDeliveryProvider = exports.CheckoutDeliveryProvider || (exports.CheckoutDeliveryProvider = {}));
var CheckoutDeliveryStatus;
(function (CheckoutDeliveryStatus) {
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["Rejected"] = -1] = "Rejected";
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["Pending"] = 0] = "Pending";
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["Received"] = 1] = "Received";
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["ReadyForPickup"] = 2] = "ReadyForPickup";
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["PickedUp"] = 3] = "PickedUp";
    CheckoutDeliveryStatus[CheckoutDeliveryStatus["Delivered"] = 4] = "Delivered";
})(CheckoutDeliveryStatus = exports.CheckoutDeliveryStatus || (exports.CheckoutDeliveryStatus = {}));
var CheckoutOrderType;
(function (CheckoutOrderType) {
    CheckoutOrderType[CheckoutOrderType["Default"] = 0] = "Default";
    CheckoutOrderType[CheckoutOrderType["PreOrder"] = 1] = "PreOrder";
    CheckoutOrderType[CheckoutOrderType["PreOrderLink"] = 2] = "PreOrderLink";
    CheckoutOrderType[CheckoutOrderType["GroupPreOrder"] = 3] = "GroupPreOrder";
})(CheckoutOrderType = exports.CheckoutOrderType || (exports.CheckoutOrderType = {}));
var CheckoutCancelActor;
(function (CheckoutCancelActor) {
    CheckoutCancelActor["Customer"] = "Customer";
    CheckoutCancelActor["CloudAdmin"] = "CloudAdmin";
    CheckoutCancelActor["Core"] = "Core";
})(CheckoutCancelActor = exports.CheckoutCancelActor || (exports.CheckoutCancelActor = {}));
var CheckoutPaymentStatus;
(function (CheckoutPaymentStatus) {
    CheckoutPaymentStatus[CheckoutPaymentStatus["Created"] = 0] = "Created";
    /** Payment was received and are pending */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Processing"] = 1] = "Processing";
    /** The payment is authorized. The payment authorize transaction was successful, Payment is waiting for OrderManager to accept or deny the order  */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Authorized"] = 3] = "Authorized";
    /** Payment is pending a capture from Adyen. Will be set to captured after notifications from Adyen */
    CheckoutPaymentStatus[CheckoutPaymentStatus["CapturePending"] = 4] = "CapturePending";
    /** The payment was successfully finished. The amount is captured and paid. */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Captured"] = 5] = "Captured";
    /** The payment is canceled by system or user for some reason.  */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Canceled"] = 6] = "Canceled";
    /** The payment is failed. Something went wrong and the payment could not be paid successfully */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Error"] = 7] = "Error";
    /** Payment was received and are pending */
    CheckoutPaymentStatus[CheckoutPaymentStatus["Received"] = 8] = "Received";
})(CheckoutPaymentStatus = exports.CheckoutPaymentStatus || (exports.CheckoutPaymentStatus = {}));
